import React, { createContext, useState } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/fp/get';

import { addLink, removeLink } from '../store/actions';
import { useAction } from '../store/utils';

export const NavigationContext = createContext();

export default function NavigationStore({ children }) {
  const [navigation] = useState({
    // useMemo does not allow nested hooks
    addLink: useAction(addLink),
    removeLink: useAction(removeLink),
    getLinks: () => useSelector(get('links')),
  });

  return (
    <NavigationContext.Provider value={navigation}>
      {children}
    </NavigationContext.Provider>
  );
}
